
import Vue, { PropType } from 'vue'

import JFileInputFile from '@/ui/controls/JFileInputFile.vue'
import JFileInputFileBox from '@/ui/controls/JFileInputFileBox.vue'

import JFileContainer from '@/models/JFileContainer'

const fileToJFileContainer = (file: File) =>
  file.constructor.name === 'JFileContainer'
    ? (file as unknown as JFileContainer)
    : new JFileContainer(file)

export default Vue.extend({
  components: {
    JFileInputFile,
    JFileInputFileBox,
  },
  props: {
    value: Array as PropType<Array<JFileContainer>>,

    accept: String,
    capture: String, // 'user' or 'environment' for camera input
    multiple: Boolean,
    append: Boolean, // append file selection instead of replace

    grid: Boolean, // show grid boxes instead of row list items
    nestedGrid: Boolean, // change margins and paddings if using nested grid

    label: String,
    appendIcon: String,
    appendOuterIcon: String,
    prependIcon: String,
    prependInnerIcon: String,

    hideDetails: Boolean,
  },
  data: () => ({
    //
  }),
  computed: {
    // inputFiles(): File[] {
    //   return this.files.map((f: JFileContainer) => f.file)
    // },
    inputFiles: {
      get(): File[] {
        return []
      },
    },
    files(): JFileContainer[] {
      return this.value
    },
    hasFilesSelected(): boolean {
      return this.files.length > 0
    },
    totalProgress(): number {
      return (
        this.files.reduce((tot, cur: JFileContainer) => tot + cur.progress, 0) /
        (this.files.length || 1)
      )
    },
    uploading(): boolean {
      return this.files.some((f: JFileContainer) => f.uploading)
    },
  },
  created() {
    //
  },
  methods: {
    emit(jfiles: JFileContainer[]) {
      this.$emit('input', jfiles)
    },
    removeFile(i: number) {
      const tempValue = this.value.slice()
      tempValue.splice(i, 1)
      this.emit(tempValue)
    },
    onChange(files: File[]) {
      if (!Array.isArray(files)) files = [files]
      if (files.length < 1) console.warn('no file selected')
      if (!this.multiple && files.length > 1)
        throw new Error('select only one file')

      if (this.append) {
        this.emit([...this.files, ...files.map(fileToJFileContainer)])
      } else {
        this.emit(files.map(fileToJFileContainer))
      }
    },
  },
})
